<template>
  <div class="stageHolder">
    <div v-show="show || showHiddenStages" class="child" :style="{ height: lineheight + 'px' }">
      <div class="childTitle font-weight-normal" @contextmenu.prevent="openStageContextMenu">
        <span v-if="draggingAllowed" :class="{ 'glyphicon-move': draggingAllowed }" aria-hidden="true">&#8597;</span>
        <span v-if="!draggingAllowed" class="glyphicon-no-move" aria-hidden="true">&nbsp;</span>
        <button @click="toggleStageChildren(stage)">
          <span v-show="stage.showChildren">↘</span>
          <span v-show="!stage.showChildren">→</span>
        </button>
        <b-icon v-if="stage.lockedDragNDrop" icon="lock-fill" class="locked" />
        <img class="locked" v-if="stage.lockedDiary" style="width: 14px; height: 14px" src="static/back.png" />
        <input
          :readonly="!editingAllowed || !hasPropertyPermissions('Stage', 'title')"
          :value="stage.title"
          @change="updateTitle"
          @copy="copy"
          @dblclick="toggleStageChildren(stage)"
          @drop.prevent=""
          @focus="focusOnTitle"
          @keydown.ctrl.76.prevent="togglelock"
          @keydown.meta.76.prevent="togglelock"
          @keyup.shift.enter="addPartToStage"
          @paste="paste"
          class="childTitle"
          ref="title"
          type="text"
        />
        <input type="checkbox" v-model="show" v-if="level === 0 && showHiddenStages" />
      </div>
    </div>

    <div v-if="stage.showChildren && (show || showHiddenStages)">
      <draggable
        @start="childMoveStart"
        :move="checkMove"
        @change="childMoved"
        v-model="filteredChildren"
        v-bind:options="{ group: 'parts', handle: '.glyphicon-move' }"
      >
        <div v-for="(child, index) in filteredChildren" :key="'title' + child._id">
          <StageTitle
            v-if="child.type == 'Stage'"
            :lineheight="lineheight"
            :lockedDragNDrop="stage.lockedDragNDrop || lockedDragNDrop"
            :level="level + 1"
            :children="child.children"
            :stage="fetchStage(child._id)"
            :filterDate="filterDate"
            :filterDateEnd="filterDateEnd"
            :filterDateZoom="filterDateZoom"
          />
          <PartTitle
            v-if="child.type == 'Part'"
            :lineheight="lineheight"
            :lockedDragNDrop="stage.lockedDragNDrop || lockedDragNDrop"
            :level="level + 1"
            :stage="stage"
            :part="fetchPart(child._id)"
            :filterDate="filterDate"
            :filterDateZoom="filterDateZoom"
          />
        </div>
      </draggable>
    </div>
  </div>
</template>
<script>
import PartTitle from './PartTitle';
import { mapGetters, mapActions } from 'vuex';
import { EventBus } from '@/common/eventbus';
import contextMenu from 'vue-context-menu';
import draggable from 'vuedraggable';
import * as stageHelpers from '@/common/stageHelpers';
import * as colourHelpers from '@/common/colourHelpers';

export default {
  name: 'StageTitle',
  data: () => {
    return {};
  },
  props: [
    'children',
    'filterDate',
    'filterDateEnd',
    'filterDateZoom',
    'level',
    'lineheight',
    'lockedDragNDrop',
    'stage',
    'showHiddenStages',
  ],
  methods: {
    ...mapActions([
      'addPart',
      'addStage',
      'copyChildNode',
      'delayedSelection',
      'parts',
      'pasteChildNode',
      'projectChildMoved',
      'saveStageProperties',
      'setStageProperties',
      'selectPart',
      'selectStage',
      'stages',
      'toggleStageChildren',
    ]),
    copy: async function (e) {
      var copy = await this.copyChildNode({ node: this.stage });
      e.clipboardData.setData('text/plain', this.stage.title);
      e.clipboardData.setData('application/json', JSON.stringify(copy, ['title', 'children'], ' '));
      e.clipboardData.setData('application/boon-object', JSON.stringify(copy));
      e.preventDefault();
    },
    paste: function (e) {
      var nodeText = e.clipboardData.getData('application/boon-object');
      if (nodeText) {
        this.pasteChildNode({ pasteOnNode: this.stage, pasteNode: JSON.parse(nodeText), startdate: this.startdate });

        e.preventDefault();
      }
    },
    childMoveStart: function (evt) {
      return this.draggingAllowed;
    },
    childMoved: function (e) {
      if (e.removed) {
        return;
      }

      e.parent = this.stage;

      var newIndex = 0;
      var movedChild = {};
      if (e.moved) {
        movedChild = e.moved.element;
        newIndex = e.moved.newIndex;
        if (e.moved.newIndex > e.moved.oldIndex) {
          newIndex++;
        }
      } else {
        movedChild = e.added.element;
        newIndex = e.added.newIndex;
      }

      var position;
      if (newIndex < this.children.length) {
        position = this.children[newIndex];
      }
      // console.log('stage:childMoved', movedChild.title, 'to above', position, 'in list', this.stage.title);
      this.projectChildMoved({ movedChild, parent: this.stage, beforeChild: position });
      return false;
    },
    checkMove: function (evt) {
      if (!this.draggingAllowedOnChildren) {
        return false;
      }
      // cons ole.log('stage relatedContext: ', evt.relatedContext.component.$parent.level);
      // this.ghostClass = 'sortable-ghost-' + evt.relatedContext.component.$parent.level;
      var valid =
        evt.draggedContext.element.type !== 'Part' ||
        evt.relatedContext.component.$el.parentElement.id !== 'innerParts';
      return valid;
    },
    addPartToStage: function (e) {
      if (e.target.value) {
        this.updateTitle(e);
      }
      // console.log('stage:addPartToStage', JSON.stringify(this.children, null, '\n'));
      if (!this.stage.showChildren) {
        this.toggleStageChildren(this.stage);
      }

      this.addPart({
        parent: this.stage,
        newPartProperties: {
          startdate: this.calculateStartdate(this.$store, this.filterDate, this.children),
          colour: colourHelpers.shadeColour(this.stage.colour, 0.4),
        },
      }).then((part) => {
        // console.log('stage.addedpart', part);
        // this.selectPart(part);
        EventBus.$emit('focusPart', part);
      });
    },
    openStageContextMenu: function (e) {
      EventBus.$emit('openStageContextMenu', {
        event: e,
        data: { stage: this.stage, startdate: this.startdate, level: this.level },
      }); // Level is neede for fine grained permissions.
    },
    focusOnTitle: function () {
      if (this.hasSimplePermissions('selectStage')) {
        this.delayedSelection({ stage: this.stage });
      }
      this.$refs['title'].focus();
      if (this.hasPropertyPermissions('Stage', 'title')) {
        this.$refs['title'].select();
      }
    },
    calculateStartdate: stageHelpers.calculateStartdate,
    updateTitle: function (e) {
      // console.debug('Stage:updateTitle', e.target.value, this.stage);
      if (this.stage.title !== e.target.value) {
        this.saveStageProperties({ updateStage: this.stage, newStageProperties: { title: e.target.value } });
      }
    },
    togglelock: function () {
      this.saveStageProperties({
        updateStage: this.stage,
        newStageProperties: { lockedDragNDrop: !this.stage.lockedDragNDrop },
      });
    },
  },
  computed: {
    ...mapGetters([
      'currentProject',
      'editingAllowed',
      'fetchPart',
      'fetchStage',
      'hasPropertyPermissions',
      'hasSimplePermissions',
      'projectDraggingAllowed',
      'viewSettings',
    ]),
    draggingAllowed: function () {
      // Lock drag on level 0.
      if (this.level === 0 && !this.hasSimplePermissions('editStageRootLevel')) {
        return false;
      }
      return !this.lockedDragNDrop && !this.stage.lockedDragNDrop && this.projectDraggingAllowed;
    },
    draggingAllowedOnChildren: function () {
      return !this.lockedDragNDrop && !this.stage.lockedDragNDrop && this.projectDraggingAllowed;
    },
    startdate: function () {
      return this.calculateStartdate(this.$store, this.filterDate, this.children);
    },
    filteredChildren: {
      get: function () {
        return this.children;
      },
      set: function (value) {
        console.log('stage:filteredChildren:set', value);
      },
    },
    show: {
      get: function () {
        return this.stage.show;
      },
      set: function (value) {
        console.log('stage:show:set', value);
        this.saveStageProperties({ updateStage: this.stage, newStageProperties: { show: value } });
      },
    },
  },
  filters: {},
  components: {
    PartTitle,
    contextMenu,
    draggable,
  },
  mounted: function () {
    var _this = this;
    EventBus.$on('focusStage', function (stage) {
      if (stage._id === _this.stage._id) {
        _this.focusOnTitle();
      }
    });
  },
  beforeDestroy() {
    EventBus.$off('focusStage');
  },
};
</script>

<style scoped>
.child {
  border-bottom: 1px solid black;
}

input {
  vertical-align: top;
  background-color: inherit;
  border: 0px;
  color: white;
}
/* This is to fix css load order diff between dev and build. */
input:read-only {
  color: #999 !important;
}

.stageHolder {
  padding-left: 10px;
}

.stageHolder input {
  text-transform: uppercase;
}

.stagePartPar {
  background: transparent;
  border: 3px solid black;
  border-radius: 0px;
  border-bottom: 0px;
}

.childTitle {
  position: relative;
  white-space: nowrap;
  height: 16px;
  display: inline-block;
  z-index: 100;
  overflow: hidden;
  font-size: 12px;
  /* width: 100%; */
}

.childTitle:focus {
  font-weight: bold;
}

.locked {
  font-size: 80%;
  position: relative;
  top: -2px;
}

input[type='checkbox'] {
  opacity: 1;
  position: absolute;
  right: 0px;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/components/projectplan/StageTitle.vue